module.exports = __webpack_public_path__ + "frontend/images/faq/screen-add-cards-xs-90c6e406ee12942985d2bed328a0174a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-add-cards-xs.jpg
// module id = 340
// module chunks = 2